onReady(($) => {
    const openLeaderDrawer = (profile, $allProfiles) => () => {
        if ($allProfiles.hasClass('active') && profile.classList.contains('active')) {
            return
        }
        $allProfiles.removeClass('active')
        profile.classList.add('active')
    }
    const closeLeaderDrawer = (profile) => () => profile.classList.remove('active')

    const $leadershipDrawerModules = $('body.ds .page-content .leadership-profile-drawers')
        .toArray()
    for (const leadershipDrawerModule of $leadershipDrawerModules) {
        const $allProfiles = $('.profile', leadershipDrawerModule);
        for (const profile of $allProfiles.toArray()) {
            profile.querySelector('.leader-card')
                .addEventListener('click', openLeaderDrawer(profile, $allProfiles))
            profile.querySelector('.close')
                .addEventListener('click', closeLeaderDrawer(profile))
        }
    }
});
